<template>
  <div class="manager_dashboard">
    <UserMenu></UserMenu>
    <div class="wrapper">
      <EnterprieSidebarMenu :show_menu="true" :show_back_button="false" back_link="managerReports"></EnterprieSidebarMenu>

      <div class="content-wrapper padding-left-165">
        <div class="container-wrapper center">
          <div class="margin-bottom-10"></div>
          <div class="row mb-3">
            <div class="col-6 pr-3">
              <div class="shadow rounded px-3 py-3">
                <div class="row align-items-end">
                  <div class="col-5" style="height: 28px !important;">
                    <div class="h6 mb-0 font-weight-bold text-uppercase" style="margin-top: 5px !important;">Earned Competencies</div>
                  </div>
                  <div class="col-4">
                    <b-form-select v-model="ecMenteeSelected" :options="menteeOptions" size="sm" @change="getCompetenciesEarned()"></b-form-select>
                  </div>
                  <div class="col-3">
                    <b-form-select v-model="ecTimeSelected" :options="timeOptions" size="sm" @change="getCompetenciesEarned()"></b-form-select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="mx-3 my-3 comp_chart_container" v-if="competencyGraghLoading == false">
                      <apexchart type="area" :options="earnedCompetenciesOptions" :series="earnedCompetenciesData"></apexchart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6 pl-3 pr-2 pl-xl-4 pr-xl-3">
              <div class="shadow rounded px-3 py-3">
                <div class="row align-items-end">
                  <div class="col-5" style="height: 28px !important;">
                    <div class="h6 mb-0 font-weight-bold text-uppercase" style="margin-top: 5px !important;">Reps Recorded</div>
                  </div>
                  <div class="col-4">
                    <b-form-select v-model="repsMenteeSelected" :options="menteeOptions" size="sm" @change="getRepRecorded()"></b-form-select>
                  </div>
                  <div class="col-3">
                    <b-form-select v-model="repsTimeSelected" :options="timeOptions" size="sm" @change="getRepRecorded()"></b-form-select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="mx-3 my-3 reps_chart_container" v-if="repsGraghLoading == false">
                      <apexchart type="area" :options="repsRecordedOptions" :series="repsRecordedData"></apexchart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6 pr-3">
              <div class="shadow rounded px-3 py-3">
                <div class="h4 mt-3 mb-3 text-uppercase">Reports</div>

                <div class="row mb-3 report-panel-container">

                  <router-link :to="{ name: 'EnterprisePathwayProgressPathwayLists' }" class="text-muted">
                  <div class="view-report border rounded text-center p-1 ml-2 text-muted" >
                    
                      <img class="report-icon" src="@/assets/manager/Mentor Mentee Progress Report Icon.png"  />
                      <p class="mb-0 small font-color-002f42">Progress</p>
                    
                  </div>
                  </router-link>


                  <router-link to="/enterprise-admin/competency-report-overview/All" class="text-muted">
                  <div class="view-report border rounded text-center p-1 ml-2 text-muted" >
                      <img class="report-icon" src="@/assets/manager/competency_report_icon.png" style="width: 19px;" />
                      <p class="mb-0 small font-color-002f42">Competency</p>
                  </div>
                  </router-link>

                  <router-link :to="{ name: 'enterpriseadminusagereport' }" class="text-muted">
                  <div class="view-report border rounded text-center p-1 ml-2 text-muted" >
                      <img class="report-icon" src="@/assets/manager/usage_report_icon.png" />
                      <p class="mb-0 small font-color-002f42">Usage</p>
                  </div>
                  </router-link>

                  <router-link to="/enterprise-admin/rep-audit-trail/All" class="text-muted">
                  <div class="border rounded text-center p-1 ml-2 text-muted view-report">
                      <img class="report-icon" src="@/assets/manager/tasks_icon_rep_audit_trail.png"  height="23px" />
                      <p class="mb-0 small font-color-002f42">Tasks</p>
                  </div>
                  </router-link>

                </div>
              </div>
            </div>
            <div class="col-6 pl-3 pr-2 pl-xl-4 pr-xl-3 margin-t-20">
                <MenteeTasksLogged
                
                ></MenteeTasksLogged>

            </div>
          </div>

          <div class="my-5"></div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VueApexCharts from 'vue-apexcharts'
import UserMenu from '@/components/shared/user_menu.vue';
import EnterprieSidebarMenu from '@/components/shared/enterpriseadmin_sidebar_menu.vue';
import DashboardNotifications from '@/components/manager/dashboard_notifications.vue';
import MenteeTasksLogged from '@/components/manager/mentee_tasks_logged.vue';
import { checkIsManager, checkIsMentor } from '@/components/shared/utils.js';

Vue.use(VueApexCharts);

export default {
  components: {
    UserMenu,
    EnterprieSidebarMenu,
    DashboardNotifications,
    MenteeTasksLogged,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      ecMenteeSelected: '',
      ecTimeSelected: '6',
      repsMenteeSelected: '',
      repsTimeSelected: '6',
      menteeOptions: [],
      competencyGraghLoading: false,
      repsGraghLoading: false,
      timeOptions: [
        {
          value: '6',
          text: '6 Months',
        },
        {
          value: '9',
          text: '9 Months',
        },
        {
          value: '12',
          text: '12 Months',
        },
      ],
      
      earnedCompetenciesData: [],
      repsRecordedData: [],
      earnedCompetenciesOptions: {},
      repsRecordedOptions: {},
    }
  },
  methods: {
    InitRepsRecorded(label, stepSize) {
      this.repsRecordedOptions = {
        chart: {
          id: 'reps_recorded_chart',
          type: 'area',
          height: 350,
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight',
          width: 2,
          colors: ['#44788e']
        },
        labels: label,
        xaxis: {
          title: {
            text: 'Months',
            style: {
              fontFamily: '"proxima-nova",sans-serif',
            },
          },
          labels: {
            style: {
              fontFamily: '"proxima-nova",sans-serif',
            }
          },
        },
        yaxis: {
          opposite: false,
          show: true,
          stepSize: stepSize,
          min: 0,
          labels: {
            show: false
          },
          title: {
            text: 'Reps Recorded',
            style: {
              fontFamily: '"proxima-nova",sans-serif',
            },
          },
          axisBorder: {
            show: true
          }
        },
        fill: {
          type: ['solid'],
          colors: ['#FFFFFF'],
          opacity: 0.0,
        },
        grid: {
          show: true,
          row: {
            colors: ['#e5f7fd'],
            opacity: 0.5,
            border: 0,
          }          
        },
      };
      this.repsGraghLoading = false;
    },
    InitEarnedCompetencies(label, stepSize) {
      this.earnedCompetenciesOptions = {
        chart: {
          id: 'earned_competencies_chart',
          type: 'area',
          height: 350,
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight',
          width: 2,
          colors: ['#44788e']
        },
        labels: label,
        xaxis: {
          title: {
            text: 'Months',
            style: {
              fontFamily: '"proxima-nova",sans-serif',
            },
          },
          labels: {
            style: {
              fontFamily: '"proxima-nova",sans-serif',
            }
          },
        },
        yaxis: {
          opposite: false,
          show: true,
          stepSize: stepSize,
          min: 0,
          labels: {
            show: false
          },
          title: {
            text: 'Competencies Earned',
            style: {
              fontFamily: '"proxima-nova",sans-serif',
            },
          },
          axisBorder: {
            show: true
          }
        },
        fill: {
          type: ['solid'],
          colors: ['#FFFFFF'],
          opacity: 0.0,
        },
        grid: {
          show: true,
          row: {
            colors: ['#74d1f6', '#a6e2f9', '#bfeafc', '#e5f7fd'],
            opacity: 0.5
          }          
        },
      };
      this.competencyGraghLoading = false;
    },
    getCompetenciesEarned() {
      this.competencyGraghLoading = true;
      axios('/desktop/v2/enterprise-report/earned-competency',
        {
          method: 'GET',
          params: {
            account_id: this.$store.state.user_accountid,
            month: this.ecTimeSelected,
            mentee_id: this.ecMenteeSelected,
          }
        })
        .then(resp => {
          
          this.earnedCompetenciesData = [{
            name: 'Competencies Earned',
            data: resp.data.earnedBarValues,
          }];
          this.InitEarnedCompetencies(resp.data.earnedBarLabels, resp.data.earnedBarStepSize);
        })
        .catch(() => {
        });

    },
    getRepRecorded() {
      this.repsGraghLoading = true;
      axios('/desktop/v2/enterprise-report/reps-recorded',
        {
          method: 'GET',
          params: {
            account_id: this.$store.state.user_accountid,
            month: this.repsTimeSelected,
            mentee_id: this.repsMenteeSelected,
          }
        })
        .then(resp => {
          this.repsRecordedData = [{
            name: 'Reps Recorded',
            data: resp.data.activityBarValues,
          }],
          
          this.InitRepsRecorded(resp.data.activityBarLabels, resp.data.activityBarStepSize);
        })
        .catch(() => {
        });
    },

    getMenteesLists() {
      axios.get('/desktop/v2/manager-report/get-mentee-lists', {
        params: {
         accountId: this.$store.state.user_accountid,
        }
      })
      .then(response =>  {
        this.menteeOptions = [
            { value: '', text: 'All Mentees' },
        ];       
        for (var i = 0; i <= response.data.length; i++) {
          var yoptions = { value: response.data[i].value, text: response.data[i].text };
          this.menteeOptions.push(yoptions);
        }
            
      })
      .catch(function() {
            
      });    

    },

  },

  created() {
    this.getMenteesLists();
    this.getCompetenciesEarned();
    this.getRepRecorded();
  },
}
</script>

<style scoped>
select {
  height: 28px;
  padding: 0 0.5rem;
}
.rounded {
  border-radius: 10px !important;
}
.comp_chart_container {
  width: 99%;
}
.reps_chart_container {
  width: 99%;
}
@media (max-width: 1199.98px) {
  .comp_chart_container {
    width: 99%;
  }
  .reps_chart_container {
    width: 99%;
  }
}
@media (max-width: 1300px) {
  .report-panel-container {
    justify-content: left;
  }
}
@media (min-width: 1301px) {
  .report-panel-container {
    justify-content: center;
  }
}
.report-icon {
  width: 25px; margin-top: 5px; margin-bottom: 10px;
}
.view-report {
   width: 112px; border-color: #002F42 !important;  
}
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/manage_reports.vue